
/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const gsuite = {
  index: r => require.ensure([], () => r(require('./components')), 'gsuite-bundle'),
  recon: r => require.ensure([], () => r(require('./components/recon')), 'gsuite-bundle'),
  grecon: r => require.ensure([], () => r(require('./components/grecon')), 'gsuite-bundle'),
  imapdetail: r => require.ensure([], () => r(require('./components/settings/imapdetail')), 'gsuite-bundle'),
  // reported_mails_new: r => require.ensure([], () => r(require('./components/reported_mails')), 'gsuite-bundle'),
  reported_mails: r => require.ensure([], () => r(require('./components/reported_mails/index')), 'gsuite-bundle'),
  welcome: r => require.ensure([], () => r(require('./components/welcome')), 'gsuite-bundle'),
  extensionInstall: r => require.ensure([], () => r(require('./components/extensionInstall')), 'gsuite-bundle'),
  showOriginal: r => require.ensure([], () => r(require('./components/reported_mails/show_original.vue')), 'gsuite-bundle'),
  users: r => require.ensure([], () => r(require('./components/users')), 'gsuite-bundle'),
  custommessages: r => require.ensure([], () => r(require('./components/settings/custommessages')), 'gsuite-bundle'),
  reportermessage: r => require.ensure([], () => r(require('./components/settings/reportermessage')), 'gsuite-bundle'),
  reportedmailbroadcast: r => require.ensure([], () => r(require('./components/settings/reportedmailbroadcast')), 'gsuite-bundle'),
  timezone: r => require.ensure([], () => r(require('./components/settings/timezone')), 'gsuite-bundle'),
  domains: r => require.ensure([], () => r(require('./components/settings/domainmanagement')), 'gsuite-bundle'),
  // edit: r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
  changepassword: r => require.ensure([], () => r(require('./components/settings/change-password')), 'gsuite-bundle'),
  suppression: r => require.ensure([], () => r(require('./components/settings/suppression')), 'gsuite-bundle'),
  adminactivity: r => require.ensure([], () => r(require('./components/settings/audittrail')), 'gsuite-bundle'),
  confirmationmessage: r => require.ensure([], () => r(require('./components/settings/confirmationmessage')), 'gsuite-bundle'),
  exportReport: r => require.ensure([], () => r(require('./components/reports/index')), 'report-bundle'),
  ciscoumbrella: r => require.ensure([], () => r(require('./components/settings/ciscoumbrella')), 'gsuite-bundle'),
  ciscoumbrellaactivedomains: r => require.ensure([], () => r(require('./components/settings/ciscoumbrellaactivedomains')), 'gsuite-bundle'),
  infoblox: r => require.ensure([], () => r(require('./components/settings/infoblox')), 'gsuite-bundle'),
  infobloxblockeddomains: r => require.ensure([], () => r(require('./components/settings/infobloxblockeddomains')), 'gsuite-bundle'),

  setrules: r => require.ensure([], () => r(require('./components/settings/esa/setrules')), 'gsuite-bundle'),
  mimecast: r => require.ensure([], () => r(require('./components/settings/mimecast')), 'gsuite-bundle'),
  mimecastactivedomains: r => require.ensure([], () => r(require('./components/settings/mimecastactivedomains')), 'gsuite-bundle'),
  // smtpdetails: r => require.ensure([], () => r(require('./components/settings/smtpdetails')), 'gsuite-bundle'),
  leaderboardsettings: r => require.ensure([], () => r(require('./components/settings/leaderboard-settings')), 'gsuite-bundle'),
  // insights: r => require.ensure([], () => r(require('./components/settings/insights')), 'gsuite-bundle'),
  reported_users: r => require.ensure([], () => r(require('./components/reported_users/reportedusers')), 'gsuite-bundle'),
  reported_user_email: r => require.ensure([], () => r(require('./components/reported_users/reporteduseremail')), 'gsuite-bundle'),
  plugin_users: r => require.ensure([], () => r(require('./components/plugin_users/pluginusers')), 'gsuite-bundle'),
  privilegedusers: r => require.ensure([], () => r(require('./components/settings/privilegeduser')), 'gsuite-bundle'),
  privilegedusersview: r => require.ensure([], () => r(require('./components/settings/privilegedusers')), 'gsuite-bundle'),
  generalsettings: r => require.ensure([], () => r(require('./components/settings/generalsettings')), 'gsuite-bundle'),
  leaderboard: r => require.ensure([], () => r(require('./components/reported_users/leaderboard')), 'gsuite-bundle'),
  socdetails: r => require.ensure([], () => r(require('./components/settings/socdetails')), 'gsuite-bundle'),
  // maliciousalert: r => require.ensure([], () => r(require('./components/settings/maliciousalert')), 'gsuite-bundle'),
  // forwardsettings: r => require.ensure([], () => r(require('./components/settings/forwardmailsettings')), 'gsuite-bundle'),
  integrations: r => require.ensure([], () => r(require('./components/integration/integrations')), 'gsuite-bundle'),
  siem_integration: r => require.ensure([], () => r(require('./components/integration/siem_integration')), 'gsuite-bundle'),
  integrationsettings: r => require.ensure([], () => r(require('./components/integration/integrations_form')), 'gsuite-bundle'),
  auditdashboard: r => require.ensure([], () => r(require('./components/audit_trails/audit_dashboard')), 'gsuite-bundle'),
  auditdetails: r => require.ensure([], () => r(require('./components/audit_trails/audit_details')), 'gsuite-bundle'),
  allauditdetails: r => require.ensure([], () => r(require('./components/audit_trails/all_audit_details')), 'gsuite-bundle'),
  marksafelogs: r => require.ensure([], () => r(require('./components/audit_trails/marksafe_logs')), 'gsuite-bundle'),
  audituserreports: r => require.ensure([], () => r(require('./components/audit_trails/audit_user_reports')), 'gsuite-bundle'),
  audittotal: r => require.ensure([], () => r(require('./components/audit_trails/audit_total_count')), 'gsuite-bundle'),
  headercontent: r => require.ensure([], () => r(require('./components/settings/headercontent')), 'gsuite-bundle'),
  emaillogs: r => require.ensure([], () => r(require('./components/logs/email_logs')), 'gsuite-bundle'),
  campaignmaillogs: r => require.ensure([], () => r(require('./components/logs/campaignmail_logs')), 'gsuite-bundle'),
  logs: r => require.ensure([], () => r(require('./components/logs/malicious_logs')), 'gsuite-bundle'),
  reviewmaillogs: r => require.ensure([], () => r(require('./components/logs/reviewmail_logs')), 'gsuite-bundle'),
  profilesettings: r => require.ensure([], () => r(require('./components/profile_settings/index')), 'gsuite-bundle'),
  advancedsettings: r => require.ensure([], () => r(require('./components/advanced_settings/index')), 'gsuite-bundle'),
  companysettings: r => require.ensure([], () => r(require('./components/company_settings/index')), 'gsuite-bundle'),

  general_settings: r => require.ensure([], () => r(require('./components/settings/general_settings')), 'gsuite-bundle'),
  personalize_settings: r => require.ensure([], () => r(require('./components/settings/personalize_settings')), 'gsuite-bundle'),
  email_security_assistant: r => require.ensure([], () => r(require('./components/settings/email_security_assistant')), 'gsuite-bundle'),
  admin_users: r => require.ensure([], () => r(require('./components/settings/admin_users')), 'gsuite-bundle'),
  role: r => require.ensure([], () => r(require('./components/settings/role')), 'gsuite-bundle'),
  new_role: r => require.ensure([], () => r(require('./components/settings/new_role')), 'gsuite-bundle'),
  edit_role: r => require.ensure([], () => r(require('./components/settings/edit_role')), 'gsuite-bundle'),
  esaAutoActionlogs: r => require.ensure([], () => r(require('./components/settings/esa/esaAutoActionlogs')), 'gsuite-bundle'),
  getrules: r => require.ensure([], () => r(require('./components/settings/esa/getrules')), 'gsuite-bundle'),
  rulesLogs: r => require.ensure([], () => r(require('./components/settings/esa/rulesLogs.vue')), 'gsuite-bundle'),
  manageSubscriptions: r => require.ensure([], () => r(require('./components/users/manage_subscriptions')), 'gsuite-bundle'),
  esa_csvReview: r => require.ensure([], () => r(require('./components/users/esa_csvReview')), 'gsuite-bundle'),
  manageSubscriptions_autoaction: r => require.ensure([], () => r(require('./components/users/manage_autoaction_subscriptions')), 'gsuite-bundle'),
  esa_csvReview_scoreBased: r => require.ensure([], () => r(require('./components/users/esa_csvReview_scoreBased')), 'gsuite-bundle'),
  // reviewConfirm: r => require.ensure([], () => r(require('./components/users/review_confirm')), 'gsuite-bundle'),
  anuallyReported: r => require.ensure([], () => r(require('./components/reports/manually_reported')), 'gsuite-bundle'),
  reporterProfile: r => require.ensure([], () => r(require('./components/reports/reporter_profile')), 'gsuite-bundle'),
  remediationThreatHunt: r => require.ensure([], () => r(require('./components/reports/remediation_threat_hunt')), 'gsuite-bundle'),
  remediationAutoScoreBased: r => require.ensure([], () => r(require('./components/reports/remediation_auto_score_based')), 'gsuite-bundle'),
  reportersLeaderboard: r => require.ensure([], () => r(require('./components/reports/reporters_leaderboard')), 'gsuite-bundle'),
  reportingTrend: r => require.ensure([], () => r(require('./components/reports/reporting_trend')), 'gsuite-bundle'),
  savedReports: r => require.ensure([], () => r(require('./components/reports/saved_reports')), 'gsuite-bundle'),
  reportingDepartmentWise: r => require.ensure([], () => r(require('./components/reports/reporting_department_wise')), 'gsuite-bundle'),
  reportingDesignationWise: r => require.ensure([], () => r(require('./components/reports/reporting_designation_wise')), 'gsuite-bundle'),
  reportingLocationWise: r => require.ensure([], () => r(require('./components/reports/reporting_location_wise')), 'gsuite-bundle'),
  attackTrend: r => require.ensure([], () => r(require('./components/reports/attack_trend')), 'gsuite-bundle'),
  mal_logs_user_list: r => require.ensure([], () => r(require('./components/logs/mal_logs_user_list')), 'gsuite-bundle'),
  tokenstatus: r => require.ensure([], () => r(require('./components/token/token_status')), 'gsuite-bundle'),
};

export default [

  {
    name: 'manage_subscriptions',
    path: '/esa-banners/manage-subscriptions',
    component: gsuite.manageSubscriptions,
    meta: { requiresAuth: true },
  },
  {
    name: 'manage_subscriptions_autoaction',
    path: '/esa-autoaction/manage-subscriptions/:type',
    component: gsuite.manageSubscriptions_autoaction,
    meta: { requiresAuth: true },
  },
  {
    name: 'esa_csvReview',
    path: '/esa-banners/subscriptions/csv-edit/:id',
    component: gsuite.esa_csvReview,
    meta: { requiresAuth: true },
  },
  {
    name: 'esa_csvReview_scoreBased',
    path: '/esa-banners/subscriptions/csv-edit-scorebased/:id',
    component: gsuite.esa_csvReview_scoreBased,
    meta: { requiresAuth: true },
  },
  {
    name: 'manually_reported',
    path: '/reports/remediation-manually-reported',
    component: gsuite.anuallyReported,
    meta: { requiresAuth: true, title: 'Remediation (Manually Reported) - Reports | EmailRemediator' },
  },
  {
    name: 'reporter_profile',
    path: '/reports/reporting-reporter-profile',
    component: gsuite.reporterProfile,
    meta: { requiresAuth: true, title: "Reporter’s Profile | EmailRemediator" },
  },
  {
    name: 'remediation_threat_hunt',
    path: '/reports/remediation-threat-hunt',
    component: gsuite.remediationThreatHunt,
    meta: { requiresAuth: true, title: 'Remediation (Threat Hunt) - Reports | EmailRemediator' },

  },
  {
    name: 'remediation_auto_score_based',
    path: '/reports/remediation-auto-score-based',
    component: gsuite.remediationAutoScoreBased,
    meta: { requiresAuth: true, title: 'Remediation Auto Score Based - Reports | EmailRemediator' },
  },
  {
    name: 'reporters_leaderboard',
    path: '/reports/reporters-leaderboard',
    component: gsuite.reportersLeaderboard,
    meta: { requiresAuth: true, title: 'Reporters Leaderboard -  Reports | EmailRemediator' },
  },
  {
    name: 'reporting_trend',
    path: '/reports/reporting-trend',
    component: gsuite.reportingTrend,
    meta: { requiresAuth: true, title: 'Reporting Trend -  Reports | EmailRemediator' },
  },
  {
    name: 'saved_reports',
    path: '/reports/saved-reports',
    component: gsuite.savedReports,
    meta: { requiresAuth: true },
  },
  {
    name: 'reporting_department_wise',
    path: '/reports/reporting-department-wise',
    component: gsuite.reportingDepartmentWise,
    meta: { requiresAuth: true },
  },
  {
    name: 'reporting_designation_wise',
    path: '/reports/reporting-designation-wise',
    component: gsuite.reportingDesignationWise,
    meta: { requiresAuth: true },
  },
  {
    name: 'reporting_location_wise',
    path: '/reports/reporting-location-wise',
    component: gsuite.reportingLocationWise,
    meta: { requiresAuth: true },
  },
  {
    name: 'attack_trend',
    path: '/reports/attack-trend',
    component: gsuite.attackTrend,
    meta: { requiresAuth: true },
  },
  {
    name: 'role',
    path: '/role',
    component: gsuite.role,
    meta: { requiresAuth: true },
  },
  {
    name: 'new_role',
    path: '/new_role',
    component: gsuite.new_role,
    meta: { requiresAuth: true },
  },
  {
    name: 'edit_role',
    path: '/edit_role',
    component: gsuite.edit_role,
    meta: { requiresAuth: true },
  },
  {
    name: 'general_settings',
    path: '/general_settings',
    component: gsuite.general_settings,
    meta: { requiresAuth: true, title: 'General - Settings | Email Remediator' },
  },

  {
    name: 'personalize_settings',
    path: '/personalize_settings',
    component: gsuite.personalize_settings,
    meta: { requiresAuth: true, title: 'Personalise - Settings | Email Remediator' },
  },
  {
    name: 'email_security_assistant',
    path: '/email_security_assistant',
    component: gsuite.email_security_assistant,
    meta: { requiresAuth: true },
  },
  {
    name: 'admin_users',
    path: '/admin_users',
    component: gsuite.admin_users,
    meta: { requiresAuth: true, title: "Admin Users - Settings | Email Remediator" },
  },


  {
    name: 'gsuite',
    path: '/gsuite',
    component: gsuite.index,
    meta: { requiresAuth: true },
  },
  // {
  //   name: 'gsuite.recon',
  //   path: '/gsuite/reconnaissance',
  //   component: gsuite.recon,
  //   meta: { requiresAuth: true },
  // },

  // {
  //   name: 'gsuite.reported_mails',
  //   path: '/gsuite/reported_mails',
  //   component: gsuite.reported_mails,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'welcome',
    path: '/welcome',
    component: gsuite.welcome,
    meta: { requiresAuth: true, title: "Install Extension | Email Remediator" },
  },
  // {
  //   name: 'gsuite.welcome',
  //   path: '/gsuite/welcome',
  //   component: gsuite.welcome,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'gsuite.extensionInstall',
    path: '/gsuite/extensionInstall',
    component: gsuite.extensionInstall,
    meta: { requiresAuth: true },
  },
  {
    name: 'gsuite.showoriginal',
    path: '/gsuite/showoriginal',
    component: gsuite.showOriginal,
    meta: { requiresAuth: true },
  },
  {
    name: 'gsuite.users',
    path: '/gsuite/users',
    component: gsuite.users,
    meta: { requiresAuth: true },
  },
  {
    name: 'grecon',
    path: '/reconnaissance',
    component: gsuite.grecon,
    meta: { requiresAuth: true, title: "Search & Remediate | Email Remediator" },
  },
  {
    name: 'recon',
    path: '/recon',
    component: gsuite.recon,
    meta: { requiresAuth: true },
  },

  {
    name: 'reported_mails',
    path: '/reported_mails',
    component: gsuite.reported_mails,
    meta: { requiresAuth: true, title: "Reported Mails | Email Remediator" },
  },
  {
    name: 'extensionInstall',
    path: '/extensionInstall',
    component: gsuite.extensionInstall,
    meta: { requiresAuth: true },
  },
  {
    name: 'showoriginal',
    path: '/showoriginal',
    component: gsuite.showOriginal,
    meta: { requiresAuth: true },
  },
  {
    name: 'users',
    path: '/users',
    component: gsuite.users,
    meta: { requiresAuth: true },
  },

  {
    name: 'custommessages',
    path: '/custommessages',
    component: gsuite.custommessages,
    meta: { requiresAuth: true },
  },
  {
    name: 'reportermessage',
    path: '/reportermessage',
    component: gsuite.reportermessage,
    meta: { requiresAuth: true },
  },
  {
    name: 'confirmationmessage',
    path: '/confirmationmessage',
    component: gsuite.confirmationmessage,
    meta: { requiresAuth: true },
  },
  {
    name: 'reportedmailbroadcast',
    path: '/reportedmailbroadcast',
    component: gsuite.reportedmailbroadcast,
    meta: { requiresAuth: true },
  },
  // {
  //   name: 'timezone',
  //   path: '/timezone',
  //   component: gsuite.timezone,
  //   meta: { requiresAuth: true },
  // },
  // {
  //   name: 'domains',
  //   path: '/domains',
  //   component: gsuite.domains,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'changepassword',
    path: '/changepassword',
    component: gsuite.changepassword,
    meta: { requiresAuth: true, title: 'Change Password' },
  },
  {
    name: 'suppression',
    path: '/suppression',
    component: gsuite.suppression,
    meta: { requiresAuth: true },
  },
  {
    name: 'adminactivity',
    path: '/adminactivity',
    component: gsuite.adminactivity,
    meta: { requiresAuth: true },
  },
  {
    name: 'exportreport',
    path: '/reports',
    component: gsuite.exportReport,
    meta: { requiresAuth: true },
  },

  {
    name: 'ciscoumbrella',
    path: '/ciscoumbrella',
    component: gsuite.ciscoumbrella,
    meta: { requiresAuth: true },
  },
  {
    name: 'infoblox',
    path: '/infoblox',
    component: gsuite.infoblox,
    meta: { requiresAuth: true },
  },
  {
    name: 'infobloxblockeddomains',
    path: '/infoblox-blocked-domains',
    component: gsuite.infobloxblockeddomains,
    meta: { requiresAuth: true },
  },
  {
    name: 'ciscoumbrellaactivedomains',
    path: '/cisco-umbrella-active-domains',
    component: gsuite.ciscoumbrellaactivedomains,
    meta: { requiresAuth: true },
  },
  {
    name: 'mimecast',
    path: '/mimecast',
    component: gsuite.mimecast,
    meta: { requiresAuth: true },
  },

  {
    name: 'mimecastactivedomains',
    path: '/mimecast-active-domains',
    component: gsuite.mimecastactivedomains,
    meta: { requiresAuth: true },
  },
  // {
  //     name: 'smtpdetails',
  //     path: '/smtp-details',
  //     component: gsuite.smtpdetails,
  //     meta: { requiresAuth: true },
  // },
  {
    name: 'leaderboardsettings',
    path: '/leaderboardsettings',
    component: gsuite.leaderboardsettings,
    meta: { requiresAuth: true },
  },
  {
    name: 'reported_users',
    path: '/reported_users',
    component: gsuite.reported_users,
    meta: { requiresAuth: true },
  },
  {
    name: 'reported_user_email',
    path: '/reported_user_email',
    component: gsuite.reported_user_email,
    meta: { requiresAuth: true },
  },
  {
    name: 'plugin_users',
    path: '/plugin_users',
    component: gsuite.plugin_users,
    meta: { requiresAuth: true },
  },
  {
    name: 'privilegedusers',
    path: '/privilegedusers',
    component: gsuite.privilegedusers,
    meta: { requiresAuth: true },
  },
  {
    name: 'privilegedusersview',
    path: '/privilegedusersview',
    component: gsuite.privilegedusersview,
    meta: { requiresAuth: true },
  },
  {
    name: 'generalsettings',
    path: '/generalsettings',
    component: gsuite.generalsettings,
    meta: { requiresAuth: true },
  },
  {
    name: 'leaderboard',
    path: '/leaderboard',
    component: gsuite.leaderboard,
    meta: { requiresAuth: true },
  },
  // {
  //   name:'imapdetail',
  //   path:'/settings/imapdetail',
  //   component:gsuite.imapdetail,
  //   meta:{requiresAuth:true}
  // },
  // {
  //   name: 'socdetails',
  //   path: '/socdetails',
  //   component: gsuite.socdetails,
  //   meta: { requiresAuth: true },
  // },
  // {
  //   name: 'maliciousalert',
  //   path: '/maliciousalert',
  //   component: gsuite.maliciousalert,
  //   meta: { requiresAuth: true },
  // },
  // {
  //   name: 'forwardsettings',
  //   path: '/forwardsettings',
  //   component: gsuite.forwardsettings,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'integrations',
    path: '/integrations',
    component: gsuite.integrations,
    meta: { requiresAuth: true },
  },
  {
    name: 'siem_integration',
    path: '/integrations/siem',
    component: gsuite.siem_integration,
    meta: { requiresAuth: true }
  },
  {
    name: 'integrationsettings',
    path: '/integrationsettings/:type',
    component: gsuite.integrationsettings,
    meta: { requiresAuth: true }
  },
  {
    name: 'auditdashboard',
    path: '/auditdashboard',
    component: gsuite.auditdashboard,
    meta: { requiresAuth: true, title: "gggg" }
  },
  {
    name: 'auditdetails',
    path: '/auditdetails/:type',
    component: gsuite.auditdetails,
    meta: { requiresAuth: true }
  },
  {
    name: 'allauditdetails',
    path: '/allauditdetails',
    component: gsuite.allauditdetails,
    meta: { requiresAuth: true }
  },
  {
    name: 'marksafelogs',
    path: '/marksafelogs',
    component: gsuite.marksafelogs,
    meta: { requiresAuth: true }
  },
  {
    name: 'audituserreports',
    path: '/audituserreports',
    component: gsuite.audituserreports,
    meta: { requiresAuth: true }
  },
  {
    name: 'audittotal',
    path: '/audittotal',
    component: gsuite.audittotal,
    meta: { requiresAuth: true }
  },
  // {
  //   name: 'headercontent',
  //   path: '/headercontent',
  //   component: gsuite.headercontent,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'emaillogs',
    path: '/emaillogs',
    component: gsuite.emaillogs,
    meta: { requiresAuth: true },
  },
  {
    name: 'campaignmaillogs',
    path: '/campaignmaillogs',
    component: gsuite.campaignmaillogs,
    meta: { requiresAuth: true },
  },
  {
    name: 'logs',
    path: '/logs/:type',
    component: gsuite.logs,
    meta: { requiresAuth: true },
  },
  {
    name: 'reviewmaillogs',
    path: '/reviewmaillogs',
    component: gsuite.reviewmaillogs,
    meta: { requiresAuth: true },
  },
  {
    name: 'profilesettings',
    path: '/profilesettings',
    component: gsuite.profilesettings,
    meta: { requiresAuth: true, title: "Profile Settings | Email Remediator" },
  },
  {
    name: 'advancedsettings',
    path: '/advancedsettings',
    component: gsuite.advancedsettings,
    meta: { requiresAuth: true, title: "Advanced Settings | Email Remediator" },
  },
  {
    name: 'companysettings',
    path: '/companysettings',
    component: gsuite.companysettings,
    meta: { requiresAuth: true, title: "Company Settings | Email Remediator" },
  },
  {
    name: 'esaautoactionlogs',
    path: '/esap',
    component: gsuite.esaAutoActionlogs,
    meta: { requiresAuth: true },
  },
  {
    name: 'setrules',
    path: '/setrules/:id?',
    component: gsuite.setrules,
    meta: { requiresAuth: true },
  },
  {
    name: 'getrules',
    path: '/remediationrules',
    component: gsuite.getrules,
    meta: { requiresAuth: true },
  },
  {
    name: 'ruleslogs',
    path: '/ruleslogs',
    component: gsuite.rulesLogs,
    meta: { requiresAuth: true },
  },
  {
    name: 'mal_logs_user_list',
    path: '/logs/malicious-banner/users/:type/:data',
    component: gsuite.mal_logs_user_list,
    meta: { requiresAuth: true },
  },
  {
    name: 'tokenstatus',
    path: '/tokenstatus',
    component: gsuite.tokenstatus,
    meta: { requiresAuth: true },
  },
]




// WEBPACK FOOTER //
// ./src/app/gsuite/routes.js